module.exports = __webpack_public_path__ + "img/ro4.d2e70ba8.jpg";